import React from 'react';
import {connect} from 'react-redux';
import { Redirect } from "react-router-dom";

const propTypes = {};

const defaultProps = {};

const mapStateToProps = state => ({});

class PageLogout extends React.Component {
	constructor(props) {
		super(props);        
	}

    state = { redirect: null };    
    
    render() {
        sessionStorage.clear();
        this.setState({ redirect: "/login" }); 	  
        return <Redirect to={this.state.redirect} /> ;
	}
}

PageLogout.propTypes = propTypes;
PageLogout.defaultProps = defaultProps;

export default connect(mapStateToProps)(PageLogout);